import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../../api/admin';
import { Spinner } from '../../components/Spinner';

interface StatCard {
  label: string;
  key: 'totalPurchased' | 'totalWagered' | 'totalPaidOut' | 'activeUsers';
}

const CARDS: StatCard[] = [
  { label: 'Tokens purchased', key: 'totalPurchased' },
  { label: 'Total wagered', key: 'totalWagered' },
  { label: 'Total paid out', key: 'totalPaidOut' },
  { label: 'Active users', key: 'activeUsers' },
];

export function AdminDashboard() {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['admin-summary'],
    queryFn: () => adminApi.dashboardSummary(),
  });

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-100">Admin dashboard</h1>

      {isLoading ? (
        <div className="flex justify-center py-10">
          <Spinner />
        </div>
      ) : isError ? (
        <p className="card text-sm text-rose-400">
          {error instanceof Error ? error.message : 'Failed to load summary.'}
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((card) => (
            <div key={card.key} className="card">
              <p className="text-sm text-slate-400">{card.label}</p>
              <p className="mt-2 text-3xl font-bold text-gold">
                {(data?.[card.key] ?? 0).toLocaleString()}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
